"use client";

import { getImageUrl } from "@/utils/getImageUrl";

export default function PdfDocComponent({ src }: { src: string }) {
  return (
    <div>
      {/* <iframe src={getImageUrl(src)} title="PDF Preview" className="w-full h-[75vh] md:h-[80vh]" /> */}
      <embed src={getImageUrl(src)} title="PDF Preview" className="w-full h-[75vh] md:h-[80vh]" />
    </div>
  );
}
